module.exports = __webpack_public_path__ + "static/media/VectorWrong.8858c027.svg";